module.exports = __webpack_public_path__ + "static/img/img-features-feature-6-i-pad.d5ba382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-6-i-pad.png
// module id = Fwou
// module chunks = 18